import React from 'react';
import { Link } from 'react-router-dom';
import PageBanner from '../components/PageBanner';

const Block = ({ title, children, id }) => (
  <section id={id} className="mb-8" data-testid={`legal-section-${id}`}>
    <h2 className="text-xl font-bold text-[#1E3A5F] mb-3 border-l-4 border-[#5BC5D4] pl-4">{title}</h2>
    <div className="text-gray-700 leading-relaxed text-sm space-y-2">{children}</div>
  </section>
);

const LegalNotices = () => {
  return (
    <div className="min-h-screen bg-[#FAF7F2]" data-testid="legal-page">
      <PageBanner title="Mentions légales" subtitle="Informations légales obligatoires" />
      <div className="container-custom py-10 max-w-4xl mx-auto">
        <div className="bg-white rounded-2xl shadow-sm p-6 md:p-10">

          <Block id="editeur" title="1. Éditeur du site">
            <ul className="list-disc ml-6 space-y-1">
              <li><strong>Dénomination légale :</strong> RHONE AMITIE (nom d'usage : Rhône Alpes Amitié Voyages — RAAV)</li>
              <li><strong>Forme juridique :</strong> Association loi 1901 (déclarée)</li>
              <li><strong>SIRET :</strong> 50511550100015</li>
              <li><strong>N° RNA :</strong> W691058405</li>
              <li><strong>TVA intracommunautaire :</strong> FR02505115501</li>
              <li><strong>Immatriculation Tourisme :</strong> IMO75100069 (par affiliation à la Fédération Nationale Génération Mouvement)</li>
              <li><strong>Adresse du siège :</strong> 3 rue Victor-Hugo, 69800 Saint-Priest</li>
              <li><strong>Email :</strong> <a href="mailto:rhoneamitie@gmail.com" className="text-[#5BC5D4] hover:underline">rhoneamitie@gmail.com</a></li>
              <li><strong>Téléphone :</strong> 07 59 59 56 44</li>
              <li><strong>WhatsApp :</strong> 06 60 41 62 18</li>
            </ul>
          </Block>

          <Block id="publication" title="2. Directeur de la publication">
            <p>Le directeur de la publication est <strong>M. Hassani Kamel</strong>, Président de l'association Rhône Amitié.</p>
            <p className="text-xs text-gray-500 italic">Pour toute demande relative au contenu publié sur le site, merci de nous contacter par email.</p>
          </Block>

          <Block id="hebergeur" title="3. Hébergement du site">
            <ul className="list-disc ml-6 space-y-1">
              <li><strong>Hébergeur :</strong> Emergent</li>
              <li><strong>Site :</strong> <a href="https://emergent.sh" target="_blank" rel="noopener noreferrer" className="text-[#5BC5D4] hover:underline">https://emergent.sh</a></li>
              <li><strong>Localisation des serveurs :</strong> Union européenne</li>
            </ul>
          </Block>

          <Block id="propriete" title="4. Propriété intellectuelle">
            <p>L'ensemble des contenus présents sur ce site (textes, photographies, logos, vidéos, mise en page) est protégé par le droit d'auteur et le droit des marques. Toute reproduction, représentation, diffusion ou exploitation sans autorisation préalable et écrite de l'association est strictement interdite et constitue une contrefaçon.</p>
            <p>Les photographies utilisées peuvent provenir des voyages organisés par l'association ou de banques d'images sous licence appropriée.</p>
          </Block>

          <Block id="responsabilite" title="5. Limitation de responsabilité">
            <p>Les informations diffusées sur ce site sont fournies à titre indicatif et sont susceptibles d'évoluer. L'association s'efforce d'assurer l'exactitude et la mise à jour des informations publiées, mais ne peut garantir leur complétude ou leur précision absolue.</p>
            <p><strong>Concernant les voyages :</strong> seuls les documents contractuels (facture, conditions générales de vente, programme détaillé envoyé après inscription) font foi en cas de divergence avec les informations publiées sur le site.</p>
            <p>L'association ne peut être tenue responsable des dommages directs ou indirects résultant de l'utilisation du site, de l'impossibilité d'y accéder, ou d'informations contenant des erreurs ou omissions.</p>
          </Block>

          <Block id="liens" title="6. Liens externes">
            <p>Le site peut contenir des liens vers des sites tiers (réseaux sociaux, partenaires, prestataires). L'association n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu, leur politique de confidentialité ou leurs pratiques.</p>
          </Block>

          <Block id="donnees" title="7. Protection des données personnelles (RGPD)">
            <p>Le traitement des données personnelles collectées via le site est détaillé dans notre <Link to="/politique-de-confidentialite" className="text-[#5BC5D4] hover:underline font-semibold">Politique de confidentialité</Link>.</p>
            <p>Pour exercer vos droits (accès, rectification, effacement, portabilité, opposition), contactez-nous à <a href="mailto:rhoneamitie@gmail.com" className="text-[#5BC5D4] hover:underline">rhoneamitie@gmail.com</a>.</p>
          </Block>

          <Block id="cgv" title="8. Conditions générales de vente">
            <p>Les conditions générales de vente applicables à nos voyages sont consultables sur la page <Link to="/cgv" className="text-[#5BC5D4] hover:underline font-semibold">Conditions générales de vente</Link> (également téléchargeables en PDF). Des informations pratiques complémentaires figurent sur la page <Link to="/informations-administratives" className="text-[#5BC5D4] hover:underline font-semibold">Informations administratives</Link>.</p>
          </Block>

          <Block id="cookies" title="9. Cookies">
            <p>Notre site utilise uniquement des cookies techniques nécessaires à son bon fonctionnement (authentification admin, sessions). Aucun cookie de suivi publicitaire ou statistique n'est déposé sans votre consentement explicite. Plus de détails dans la <Link to="/politique-de-confidentialite" className="text-[#5BC5D4] hover:underline font-semibold">Politique de confidentialité</Link>.</p>
          </Block>

          <Block id="droit" title="10. Droit applicable et juridiction">
            <p>Les présentes mentions légales sont régies par le <strong>droit français</strong>. En cas de litige, et après tentative de recherche d'une solution amiable, les tribunaux français seront seuls compétents.</p>
          </Block>

          <Block id="contact" title="11. Nous contacter">
            <p>Pour toute question relative à ces mentions légales, au site, ou à l'association :</p>
            <ul className="list-disc ml-6 space-y-1">
              <li>📧 Email : <a href="mailto:rhoneamitie@gmail.com" className="text-[#5BC5D4] hover:underline">rhoneamitie@gmail.com</a></li>
              <li>📞 Téléphone : 07 59 59 56 44</li>
              <li>📱 WhatsApp : 06 60 41 62 18</li>
              <li>📝 Formulaire : <Link to="/contact" className="text-[#5BC5D4] hover:underline">page Contact</Link></li>
            </ul>
          </Block>

          <p className="text-xs text-gray-500 italic mt-8 text-center">Dernière mise à jour : avril 2026</p>
        </div>
      </div>
    </div>
  );
};

export default LegalNotices;
